import {useParams} from "react-router-dom";
import {useGetEnumsQuery} from "../../../../app/globalApi";
import {DataTable} from "../../../../components/common/datatable/DataTable";
import {hasPermission} from "../../../../helpers/utils/AccessControlUtils";
import {getEnumDisplayNameByConstant} from "../../../../helpers/utils/EnumUtils";
import {useDeleteTeamRuleMutation, useLazyGetPreviewOrderListQuery, useTeamRulesQuery} from "../teamsApi";
import ModalButton from "../../../../components/common/form/ModalButton";
import {FaPlay, FaPlus, FaTrash} from "react-icons/fa6";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";
import React, {FormEvent, useState} from "react";
import AddUpdateRule from "../modal/AddUpdateRule";
import {DataTableColumn} from "../../../../components/common/datatable/DataTableTypes";
import TailSpinLoader from "../../../../components/common/TailSpinLoader";
import {showToast} from "../../../../helpers/utils/Utils";

const RuleTab = () => {

    document.title = `Rules`;

    let {teamId} = useParams();
    const {data: enums} = useGetEnumsQuery("");
    const [selectedRuleId, setSelectedRuleId] = useState("");
    const [deleteRuleApi, {isLoading: deleteRuleApiResponse}] = useDeleteTeamRuleMutation();
    const [orderDataList, orderListApiRes] = useLazyGetPreviewOrderListQuery();
    const teamRuleData = useTeamRulesQuery({teamId: teamId})
    const [showTeamRuleAddForm, setShowTeamRuleAddForm] = useState(false);
    const [teamRuleId, setTeamRuleId] = useState<any>("");
    const [runRule, setRunRule] = useState<any>("");

    const handleDeleteRuleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (selectedRuleId) {
            return deleteRuleApi(selectedRuleId);
        }
    }

    const columns: DataTableColumn[] = [
        {
            label: "Priority", accessor: "weight",
            cell: (props: any) => {
                return <>
                    <a
                        onClick={() => {
                            setTeamRuleId(props.row.original.id);
                            setShowTeamRuleAddForm(true);
                        }}
                        className="text-highlight-0  cursor-pointer">{props.value}</a>
                </>
            },

        },
        {
            label: "Order Statuses", accessor: "ruleQueryParameters.orderStatuses",
            cell: (props: any) => {
                let content = props.row.original.ruleQueryParameters?.orderStatuses?.map((cur: any) => {
                    return getEnumDisplayNameByConstant(enums?.["OrderStatus"], cur);
                }).join(", ");

                return <><span className="text_wrap_msa_grid" title={content}>{content}</span></>
            }, canSort: false,
        },
        {
            label: "Product Types", accessor: "ruleQueryParameters.productTypes",
            cell: (props: any) => {
                let content = props.row.original.ruleQueryParameters?.productTypes?.map((cur: any) => {
                    return getEnumDisplayNameByConstant(enums?.["ProductType"], cur);
                }).join(", ");

                return <><span className="text_wrap_msa_grid" title={content}>{content}</span></>
            }, canSort: false,
        },
        {
            label: "Product Statuses", accessor: "ruleQueryParameters.productStatuses", cell: (props: any) => {
                let content = props.row.original.ruleQueryParameters?.productStatuses?.map((cur: any) => {
                    return getEnumDisplayNameByConstant(enums?.["ProductStatus"], cur);
                }).join(", ");
                return <><span className="text_wrap_msa_grid" title={content}>{content}</span></>
            }, canSort: false,
        },
        {
            label: "States", accessor: "ruleQueryParameters.stateAbbreviations",
            cell: (props: any) => {
                // Access the list of states from the row's data
                let content = props.row.original.ruleQueryParameters?.stateAbbreviations?.join(", ") || "";

                // Render the content inside a span with a title attribute for the full list
                return (
                    <span className="text_wrap_msa_grid" title={content}>
                        {content}
                    </span>
                );
            }, canSort: false,
        },

        {
            label: "Counties", accessor: "countyName",
            cell: (props: any) => {
                // Access the list of counties from the row's data
                let content = props.row.original.ruleQueryParameters?.countyNames?.join(", ") || "";

                return (
                    <span className="text_wrap_msa_grid" title={content}>
                        {content}
                    </span>
                );
            }, canSort: false,
        },
        {
            label: "Metro Area", accessor: "ruleQueryParameters.metroArea", canSort: false,
        },
        {
            label: "Customers", accessor: "customers", canSort: false,
            cell: (props: any) => {
                let content = props.row.original.customers.map((curCustomer: any) => {
                    return curCustomer.customerName;
                }).join(", ");
                return <><span className="text_wrap_msa_grid" title={content}>{content}</span></>
            },
        },
        {
            label: "Branches", accessor: "branches", cell: (props: any) => {
                let content = props.row.original.branches.map((curCustomer: any) => {
                    return curCustomer.name;
                }).join(", ");
                return <><span className="text_wrap_msa_grid" title={content}>{content}</span></>
            }, canSort: false,
        },
        {
            label: "Action",
            visibility: {
                canColumnShow: hasPermission(["TEAM-U"]),
                showByDefault: hasPermission(["TEAM-U"]),
                hasShowSetting: false,
            },
            accessor: "creationDate",
            canSort: false,
            cell: (props: any) => {
                return <>
                    <div className="ml-4">
                        {hasPermission(["TEAM-U"]) && (
                            <ModalButton
                                triggerButton={
                                    <FaTrash
                                        className={"cursor-pointer text-highlight-0 text-lg hover:text-highlight-7"}
                                        title={"Delete Team Rule"}/>
                                }
                                onOpen={() => {
                                    setSelectedRuleId(props.row.original.id)
                                }}
                                modal={
                                    <ConfirmationModal
                                        show={true}
                                        setShow={() => {
                                        }}
                                        title={"Delete Team Rule"}
                                        bodyMessage={`Are you sure you want to delete this Team Rule ?`}
                                        onSubmit={handleDeleteRuleSubmit}
                                        isLoading={deleteRuleApiResponse}
                                    />
                                }
                            />
                        )}
                    </div>
                </>
            }
        },
        {
            label: "Preview",
            visibility: {
                canColumnShow: hasPermission(["TEAM-U"]),
                showByDefault: hasPermission(["TEAM-U"]),
                hasShowSetting: false,
            },
            accessor: "modifiedDate",
            canSort: false,
            cell: (props: any) => {
                return <>
                    {orderListApiRes.isFetching && (runRule === props.row.original.id || runRule === "All") ?
                        <TailSpinLoader/> : <i className={"fa fa-play pr-5 m-md-0"}
                                               title={"Run Rule"}
                                               onClick={async () => {
                                                   setRunRule(props.row.original.id);

                                                   const result = await orderDataList({
                                                       type: "runOneRule",
                                                       teamId: "teamId",
                                                       teamRuleId: props.row.original.id,
                                                       count: 10
                                                   });

                                                   // Optional chaining in case data shape isn't guaranteed
                                                   const orders = result?.data;

                                                   if (!orders || orders.length === 0) {
                                                       showToast("No Order Found!!!", "success");
                                                   }
                                               }}
                        />}

                </>
            }
        },
    ]

    function getPreviewOrdersList(e: any) {
        e.preventDefault()
        const result:any = orderDataList({
            type: "RunAllRules", teamId: teamId, teamRuleId: "teamRuleID", count: 10
        })
        const orders = result?.data;

        if (!orders || orders.length === 0) {
            showToast("No Order Found!!!", "success");
        }
    }

    return (
        <>
            {hasPermission(["TEAM-U"]) &&
                <div className="flex justify-end gap-2 items-center mb-2 absolute top-0 right-0">
                    <div
                        className={
                            orderListApiRes.isFetching || (teamRuleData.data && teamRuleData.data.data.length === 0)
                                ? "h-7 w-10 text-text-0 text-sm rounded-md bg-text-2 flex justify-center items-center cursor-not-allowed"
                                : "h-7 w-10 text-text-0 text-sm rounded-md bg-highlight-0 flex justify-center items-center cursor-pointer"
                        }
                        onClick={(e) => {
                            if (!orderListApiRes.isFetching && teamRuleData.data && teamRuleData.data.data.length !== 0) {
                                setRunRule("All");
                                getPreviewOrdersList(e);
                            }
                        }}
                    >
                        <FaPlay/>
                    </div>

                    <ModalButton
                        triggerButton={
                            <div
                                className="h-7 w-10 text-text-0 rounded-md bg-highlight-0 flex justify-center items-center cursor-pointer ">
                                <FaPlus/>
                            </div>
                        }

                        modal={
                            <AddUpdateRule
                                show={true}
                                setShow={() => {
                                }}
                                title={"Create Team Rule"}
                                btnText={"Create"}
                            />
                        }
                    />
                </div>

            }

            <div className=''>
                <DataTable
                    columns={columns}
                    actions={{
                        fetchAction: useTeamRulesQuery
                    }}
                    defaultFilter={{
                        teamId: teamId
                    }}
                    userSettingGroup={"Team Rule"}
                    appendFilterToUrl={false}
                    defaultSortOptions={{
                        accessor: "weight",
                        direction: "desc"
                    }}
                />
            </div>
            {showTeamRuleAddForm &&
                <AddUpdateRule
                    show={showTeamRuleAddForm}
                    setShow={setShowTeamRuleAddForm}
                    teamRuleId={teamRuleId}
                    title={"Update Team Rule"}
                    btnText={"Update"}
                />}
        </>
    )
}
export default RuleTab;